import { formsWithTrackBySubmit } from '../config/track-by-submit';

export const getTrackBySubmitFunction = (formId: string): Function => {
    const getTrackBySubmitFuncReference = formsWithTrackBySubmit[formId];

    if (!getTrackBySubmitFuncReference) {
        throw new Error('Unknown formId - No tracking function defined: ' + formId);
    }

    return getTrackBySubmitFuncReference;
};

export const hasTrackingBySubmitFunction = (formId: string): boolean => {
    return formId in formsWithTrackBySubmit;
};
